import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'scenic-ticket-scenic',
  name: '适用商户',
  icon: '店',
  group: '门票详情',
  description: '本票适用的景区（商户）卡片：名称、评分、营业时间与导航/电话。',
  defaultProps: {
    title: '适用商户',
    showRating: true,
    showBusinessHours: true,
    showLocation: true,
    showDistance: true
  }
}
